import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError, AxiosResponse } from 'axios';
import { Button } from 'components/universal/button';
import Heading from 'components/universal/heading';
import { Input } from 'components/universal/input';
import Paragraph from 'components/universal/paragraph';
import { PATHS } from 'constants/routes';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { sendEmailForPasswordReset } from 'services/registration';
import { APIErrors } from 'types/api';
import { ResetPasswordDTO } from 'types/user';
import clsResetPassword from './reset-password.module.scss';
import { schema } from './validation';

export interface IResetPasswordValues {
    email: string;
}

export const ResetPasswordView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<IResetPasswordValues>({
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
        },
    });

    const onSubmit = (DTO) => resetPasswordMutation.mutate(DTO);

    const resetPasswordMutation = useMutation<
        AxiosResponse,
        AxiosError<APIErrors>,
        ResetPasswordDTO
    >((data) => sendEmailForPasswordReset(data), {
        onSuccess: () => {
            navigate(PATHS.CONFIRM_RESET_PASSWORD, {
                state: {
                    email: watch('email'),
                },
            });
        },
    });

    const onCancel = () => {
        navigate(PATHS.LOGIN);
    }

    return (
        <div
            className={clsResetPassword.wrapper}
        >
            <Heading
                className={clsResetPassword.heading}
                headingLevel="h1"
                headingStyle="h2"
            >
                {t('resetPassword.title')}
            </Heading>
            <Paragraph className={clsResetPassword.paragraph}>
                {t('resetPassword.desc1')}
            </Paragraph>
            <form className={clsResetPassword.form} onSubmit={handleSubmit(onSubmit)}>
                <Input
                    className={`${clsResetPassword.input} mb-4`} 
                    register={register}
                    id="email"
                    name="email"
                    label={t('resetPassword.email')}
                    error={t(errors.email?.message)}
                    maxLength={255}
                />
                <div 
                    className={clsResetPassword.buttonWrapper} 
                >
                    <Button 
                        className={`${clsResetPassword.button} mx-auto mb-5`} 
                        styleType="border"
                        onClick={onCancel}
                        type="button"
                    >
                        {t('resetPassword.goBackButton')}
                    </Button>

                    <Button 
                        className={`${clsResetPassword.button} mx-auto mb-5`} 
                        type="submit"
                    >
                        {t('resetPassword.buttonText')}
                    </Button>
                </div>
            </form>
        </div>
    );
};


